import React from 'react';

import { RescheduleNotice } from '@src/features/sales/reschedule';
import { RescheduleModal } from '@src/features/sales/reschedule/legacy';
import { ReservationVouchersModal, VoucherSummaryCard } from '@src/features/vouchers';

import { ReservationActions } from '../ReservationActions';
import { ReservationAdditionalsRow } from '../ReservationAdditionalsRow';
import { ReservationResourceRow } from '../ReservationResourceRow';
import { ReservationScheduleRow } from '../ReservationScheduleRow';
import { ReservationSupplierRow } from '../ReservationSupplierRow';
import { useReservationCard, type UseReservationCardParams } from '../../hooks/useReservationCard';
import { ReservationCardRoot, ReservationInfo, ReservationTitle } from '../../styles';

export const ReservationCard = (props: UseReservationCardParams) => {
  const { saleItem } = props;
  const card = useReservationCard(props);

  return (
    <ReservationCardRoot data-testid={`reservation-card-${saleItem.id}`}>
      <ReservationInfo>
        <ReservationTitle>{card.productName}</ReservationTitle>

        <ReservationSupplierRow name={card.supplier.name} logoUrl={card.supplier.logoUrl} />
        <ReservationScheduleRow date={card.schedule.date} time={card.schedule.time} />

        {card.resources ? <ReservationResourceRow resources={card.resources} /> : null}

        <ReservationAdditionalsRow
          additionals={card.additionals.visible}
          overflowCount={card.additionals.overflowCount}
          overflowAs={card.additionals.overflowAs}
          onShowAll={card.additionals.showAll}
        />
      </ReservationInfo>

      <RescheduleNotice notice={card.notice} />

      {card.voucherSummary.total > 0 ? (
        <VoucherSummaryCard total={card.voucherSummary.total} onViewAll={card.voucherList.open} />
      ) : null}

      <ReservationActions
        showsReschedule={card.reschedule.showsTrigger}
        isRescheduleEnabled={card.reschedule.isEnabled}
        rescheduleTooltip={card.reschedule.tooltip}
        onReschedule={card.reschedule.start}
        showsDownload={card.voucherSummary.total > 0}
        isDownloadDisabled={card.download.isBlocked}
        downloadTooltip={card.download.pendingTooltip}
        isDownloading={card.download.isRunning}
        onDownload={card.download.run}
      />

      <ReservationVouchersModal
        open={card.voucherList.isOpen}
        onClose={card.voucherList.close}
        title={card.productName}
        vouchers={card.vouchers}
        reservationId={props.reservationId}
      />

      {card.reschedule.isOpen ? (
        <RescheduleModal
          reservationId={saleItem.id}
          saleItem={saleItem}
          onCancel={card.reschedule.cancel}
          onConfirm={card.reschedule.confirm}
        />
      ) : null}
    </ReservationCardRoot>
  );
};

export default ReservationCard;
